import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch Location list
 * @param {Object} filters
 *  @param {Number} page Page number
 *  @param {Number} size list size
 *  @param {String} name search text
 *  @param {String} sort sorting format: field;ASC|DESC
 */
const fetchCategoryList = async function ({ page, size, name, sort }) {
  try {
    let filters = {
      page, size, name, sort
    }
    console.log('TCL: filters', filters)
    const res = await axios.get(urls.categoryList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a category detail
 * @param {Number} id Category Id
 */
const fetchCategoryDetail = async function (id) {
  try {
    let res = await axios.get(urls.categoryDetail + '/' + id)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a category sub categories
 * @param {Number} categoryId category Id
 */
const fetchSubCategories = async function (categoryId) {
  try {
    let res = await axios.get(urls.subCategories(categoryId))
    console.log('TCL: res', res)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create or edit a category
 * @param {Object} form data form input
 *  @param {String} form.name category name
 *  @param {Array.<{id: Number, name: String}>|Array.<String>} [form.subCategory] sub categories of the category, send the sub category object if editing, otherwise just send a string in the array
 * @param {Number} id category Id for edit
 */
const createEditCategory = async function (form, id) {
  try {
    let res
    console.log('TCL: createEditCategory -> data, id', form, id)
    if (id) {
      res = await axios.put(urls.categoryDetail + '/' + id, form)
    } else {
      res = await axios.post(urls.categoryDetail, form)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * delete a category
 * @param {Number} id Category id
 */
const deleteCategory = async function (id) {
  try {
    let res = await axios.delete(urls.categoryDetail + '/' + id)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchCategoryList,
  fetchCategoryDetail,
  fetchSubCategories,
  createEditCategory,
  deleteCategory,
}
